var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlane = function SvgPlane(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M15.854 8.125c1.018 0 2.789.85 2.789 1.875 0 1.055-1.771 1.875-2.789 1.875h-3.47l-2.991 5.153a.95.95 0 0 1-.828.472H6.893a.472.472 0 0 1-.458-.598l1.458-5.027h-3.06l-1.285 1.688a.48.48 0 0 1-.381.187h-1.25a.413.413 0 0 1-.402-.524L2.452 10l-.937-3.226a.413.413 0 0 1 .402-.524h1.25c.148 0 .291.07.38.188l1.286 1.687h3.063L6.438 3.098a.468.468 0 0 1 .455-.598h1.672a.96.96 0 0 1 .828.472l2.99 5.153z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlane);
export default ForwardRef;